import styled, { css } from 'styled-components'

const designerCSS = css`
  &#page_wrapper {
    overflow: auto;
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    position: relative;
    overflow: hidden;
  }
  #main {
    position: relative;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex: 1 1 auto;
    z-index: 2;
    overflow-y: hidden;
  }
  .content {
    height: calc(100% + 15px);
    height: 100%;
    transition: width 300ms ease-in-out;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
    padding: 0 0 0 0;
    overflow: hidden;
  }
  #game_main_area {
    width: 100%;
    display: flex;
    flex-flow: row;
    justify-content: space-between;
    padding: 0 0 0 0;
    height: 100%;
    position: relative;
    padding: 0;
  }
`

const developerCSS = css``

export const PageWrapperCSS = styled.div`
  ${designerCSS}
  ${developerCSS}
`
